import styled from 'styled-components';
import zIndex from '../../../../../globalVariables/zIndex';
import realtimeFonts from '../../../fonts';
import {EventMenuForm} from '../../../../../layout/eventMenu/EventMenu.css';
import {alignCenter, dFlex, dFlexBetween, dFlexColumn} from '../../../../../globalVariables/GlobalFlex';
import {dFlexCenter} from '../../../../../globalVariables/GlobalVariables';

export const wrap = styled.div`
  width: 100%;
  ${dFlexColumn}
  ${dFlexCenter}
  padding: 20px;
  border-radius: 12px;
`;

export const header = styled.div`
  ${dFlexBetween};
  width: 100%;
  margin-bottom: 10px;
`;

export const text = styled.div`
  ${realtimeFonts.windowTitle}
`;

export const button = styled(EventMenuForm)`
  margin-inline-end: 50px;
`;

export const percentage = styled.div`
  ${realtimeFonts.percentage}
  text-align: center;
`;

export const chartContainer = styled.div`
  ${dFlex}
  ${alignCenter}
  height: 200px;
  width: 100%;
  min-height: 55%;
  position: relative;
  z-index: ${zIndex.baseRaised};
  *:focus {
    outline: none;
  }
`;

export const ratio = styled.div`
  ${realtimeFonts.text}
  text-align: center;
`;

export const legend = styled.div`
  margin-top: 15px;
  text-align: right;
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 8px 24px;
  justify-content: end;
`;

export const legendItem = styled.div`
  ${realtimeFonts.text}
  ${dFlex}
  ${alignCenter}
  gap: 12px;
  &::before {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${props => props.color};
    margin-right: 8px;
  }
`;
